import {
  Autocomplete,
  Button,
  Dialog,
  DialogContent,
  Grid,
  InputAdornment,
  Slide,
  TextField,
  Typography,
} from "@mui/material";
import { forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import {
  EPaymentTransfer,
  setDialog,
} from "../../../../../app/slices/ePaymentTransferSlice";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const NumericFormatCustom = forwardRef(function NumericFormatCustom(
  props,
  ref,
) {
  const { onChange, ...other } = props;
  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      valueIsNumericString
    />
  );
});

// The transfer action accepts only these four types, so they are fixed here
// rather than taken from the /e-payment-transfer-types list used by the filter.
const TRANSFER_TYPES = [
  { id: 1, name: "رصيد" },
  { id: 2, name: "تسديد ديون" },
  { id: 3, name: "الجملة" },
  { id: 4, name: "تحويل لنقطة بيع" },
];

const EPaymentTransferForm = () => {
  const dispatch = useDispatch();

  const user = useSelector((state) => state.user.user.form);
  const _Dialog = useSelector((state) => state.ePaymentTransfer.dialog);
  const _Loading = useSelector(
    (state) => state.ePaymentTransfer.ePaymentTransfer.loading,
  );
  const _SearchBody = useSelector((state) => state.ePaymentTransfer.searchBody);

  const { control, handleSubmit } = useForm({
    defaultValues: {
      amount: "",
      transfer_type_id: null,
    },
  });

  // The dialog is mounted only while open, so the form resets on each open.
  const handleDialog = () => {
    dispatch(setDialog(false));
  };

  const onSubmit = (data) => {
    dispatch(
      EPaymentTransfer.create(
        {
          amount: data.amount,
          transfer_type_id: data.transfer_type_id,
          user_id: user.id,
        },
        _SearchBody,
      ),
    );
  };

  return (
    <Dialog
      open={_Dialog}
      TransitionComponent={Transition}
      keepMounted
      fullWidth={true}
      dir="rtl"
      onClose={handleDialog}
      aria-describedby="e-payment-transfer-dialog-description"
    >
      <DialogContent>
        <Typography
          mb={3}
          variant="h4"
          color={"purple"}
          gutterBottom
          component="div"
        >
          مناقلة الدفع الالكتروني
        </Typography>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Controller
                name="transfer_type_id"
                control={control}
                rules={{ required: true }}
                render={({ field, fieldState }) => (
                  <Autocomplete
                    options={TRANSFER_TYPES}
                    getOptionLabel={(option) => option.name || ""}
                    value={
                      TRANSFER_TYPES.find((x) => x.id === field.value) ?? null
                    }
                    onChange={(e, newValue) =>
                      field.onChange(newValue ? newValue.id : null)
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        required
                        size="small"
                        label="نوع المناقلة"
                        error={!!fieldState.error}
                      />
                    )}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                name="amount"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <TextField
                    required
                    size="small"
                    label="المبلغ"
                    fullWidth
                    {...field}
                    InputProps={{
                      inputComponent: NumericFormatCustom,
                      startAdornment: (
                        <InputAdornment position="start">IQD</InputAdornment>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={_Loading}
              >
                حفظ
              </Button>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default EPaymentTransferForm;
